import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpLoadingService } from './http-loading.service';

@Injectable()
export class HttpLoadingIterceptorService implements HttpInterceptor {
  private httpLoadingService = inject(HttpLoadingService);

  private requests: any[] = new Array<any>();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requests.push(req);
    this.httpLoadingService.showLoadingIndicator();
    return new Observable<HttpEvent<any>>((observer) => {
      const subscription = next.handle(req).subscribe(
        (httpEvent) => {
          if (httpEvent.type === HttpEventType.Response) {
            this.removeRequest(req);
            observer.next(httpEvent);
          }
        },
        (error: any) => {
          console.error(error);
          this.removeRequest(req);
          observer.error(error);
        },
        () => {
          this.removeRequest(req);
          observer.complete();
        }
      );
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }

  removeRequest(request: HttpRequest<any>) {
    const index = this.requests.indexOf(request);
    if (index >= 0) {
      this.requests.splice(index, 1);
    }
    if (!this.requests.length) {
      this.httpLoadingService.hideLoadingIndicator();
    }
  }
}
